import React, { useCallback, useEffect, useMemo, useState } from "react";
import { getUserListAction } from "../../../../state/usecase/admin/user/actions";
import { Paths } from "../../../../Paths";
import { AddButton } from "../../common/button/AddButton";
import { useUserList } from "../../../hooks/admin/user/useUserList";
import { useAppDispatch } from "../../../../state/store";
import { compareString } from "../../../funcs/compare";
import { UserList } from "./list/UserList";
import { useNavigate } from "react-router-dom";

export function AdminUserListPage() {
    const dispatch = useAppDispatch();

    const navigate = useNavigate();

    const [searchKeyword, setSearchKeyword] = useState("");

    const [sortAscByUserName, setSortAscByUserName] = useState(false);

    const [sortDescByUserName, setSortDescByUserName] = useState(false);

    const [sortAscByEmail, setSortAscByEmail] = useState(false);

    const [sortDescByEmail, setSortDescByEmail] = useState(false);

    const users = useUserList();

    useEffect(() => {
        dispatch(getUserListAction());
    }, [dispatch]);

    const handleSearchEvent = useCallback((event: React.ChangeEvent<HTMLInputElement>) => setSearchKeyword(event.target.value), []);

    const handleSortByUserName = useCallback((nextSortOrder: string) => {
        if (nextSortOrder === "asc") {
            setSortAscByUserName(true);
            setSortDescByUserName(false);
        } else {
            setSortAscByUserName(false);
            setSortDescByUserName(true);
        }
        setSortAscByEmail(false);
        setSortDescByEmail(false);
    }, []);

    const handleSortByEmail = useCallback((nextSortOrder: string) => {
        setSortAscByUserName(false);
        setSortDescByUserName(false);
        if (nextSortOrder === "asc") {
            setSortAscByEmail(true);
            setSortDescByEmail(false);
        } else {
            setSortAscByEmail(false);
            setSortDescByEmail(true);
        }
    }, []);

    const handleAddClicked = useCallback(() => navigate(`${Paths.admin}${Paths.user}${Paths.add}`), [navigate]);

    const displayList = useMemo(() => {
        if (!users) return null;

        // keyword検索
        const searchList = searchKeyword.length ? users.slice().filter((data) => data.name.value.includes(searchKeyword) || data.email.value.includes(searchKeyword)) : users;
        if (searchList.length === 0) return [];

        // ソート
        let sortList = [];
        if (sortAscByUserName) {
            sortList = searchList.slice().sort((firstData, secondData) => {
                return compareString("asc", firstData.name.value, secondData.name.value);
            });
        } else if (sortDescByUserName) {
            sortList = searchList.slice().sort((firstData, secondData) => {
                return compareString("desc", firstData.name.value, secondData.name.value);
            });
        } else if (sortAscByEmail) {
            sortList = searchList.slice().sort((firstData, secondData) => {
                return compareString("asc", firstData.email.value, secondData.email.value);
            });
        } else if (sortDescByEmail) {
            sortList = searchList.slice().sort((firstData, secondData) => {
                return compareString("desc", firstData.email.value, secondData.email.value);
            });
        } else {
            sortList = searchList;
        }

        return sortList;
    }, [users, searchKeyword, sortAscByEmail, sortAscByUserName, sortDescByEmail, sortDescByUserName]);

    return (
        <div className={"user_list_page"}>
            <div className={"container"}>
                <p className={"header"}>ユーザー一覧</p>
                <div className={"search_area"}>
                    <input className={"text_box__input"} type="search" placeholder={"氏名またはメールアドレスで検索"} value={searchKeyword} onChange={handleSearchEvent} />
                </div>
                <div className="row" onClick={handleAddClicked}>
                    <AddButton label="ユーザーを追加する" onClick={handleAddClicked}/>
                </div>
                <table className={"user_list"}>
                    <thead>
                        <tr>
                            <th className={"user_name"}>ユーザー名</th>
                            <th className={"email"}>Eメール</th>
                            <th className={"control"}></th>
                        </tr>
                        <tr>
                            <th className={"user_name"}>
                                <div className={"sort_button_area"}>
                                    <button className={"sort_button"} type={"button"} onClick={() => handleSortByUserName("asc")}>▲</button>
                                    <button className={"sort_button"} type={"button"} onClick={() => handleSortByUserName("desc")}>▼</button>
                                </div>
                            </th>
                            <th className={"email"}>
                                <div className={"sort_button_area"}>
                                    <button className={"sort_button"} type={"button"} onClick={() => handleSortByEmail("asc")}>▲</button>
                                    <button className={"sort_button"} type={"button"} onClick={() => handleSortByEmail("desc")}>▼</button>
                                </div>
                            </th>
                            <th className={"control"}></th>
                        </tr>
                    </thead>
                    <UserList userList={displayList} />
                </table>
            </div>
        </div>
    );
}
